import {SvgIcon} from "@progress/kendo-react-common";
import {Button, buttonThemeColors} from "./Button.jsx";

export const SvgIconButton = ({onClick, themeColor = buttonThemeColors.base, svgIcon, iconSize = "medium", ...otherProps}) => {

    const styles = {
        padding: "8px 16px",
        ...otherProps.style
    }

    return (
        <Button onClick={onClick} style={styles}>
            <SvgIcon icon={svgIcon} size={iconSize}/>
        </Button>
    )
}